import Cookies from "js-cookie"; // Импортируем js-cookie

export const sendData = async (data) => {
  try {
    const response = await fetch("/api/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return await response.json(); // Убедитесь, что правильно обрабатываете ответ
  } catch (error) {
    console.error("Ошибка при отправке данных:", error);
    return { success: false, message: "Ошибка сервера" }; // Возвращайте объект с успехом
  }
};
export const fetchData = async () => {
  const login = Cookies.get("login");
  const hash = Cookies.get("session");

  try {
    const response = await fetch("/api/get_data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ login, hash }),
    });
    const data = await response.json();

    if (!response.ok) {
      if (response.status === 401) {
        logout();
        throw new Error(data.message || "Не зарегистрированный пользователь");
      } else {
        throw new Error(data.message || "Ошибка при получении данных");
      }
    }

    return data;
  } catch (error) {
    console.error("Error during fetch:", error);
    throw error;
  }
};

export const fetchClientData = async () => {
  try {
    const response = await fetch("/api/get_data_client", {});
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Ошибка при получении данных");
    }

    return data;
  } catch (error) {
    console.error("Error during fetch:", error);
    throw error;
  }
};

export const sendStatusData = async (data) => {
  const login = Cookies.get("login");
  const hash = Cookies.get("session");

  const newStatusData = Object.assign({}, data, { login });
  const newStatusData2 = Object.assign({}, newStatusData, { hash });
  try {
    const response = await fetch("/api/statusSubmit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newStatusData2),
    });
    const data = await response.json();

    if (!response.ok) {
      if (response.status === 401) {
        logout();
        throw new Error(data.message || "Не зарегистрированный пользователь");
      } else {
        throw new Error(data.message || "Ошибка при получении данных");
      }
    }

    return data;
  } catch (error) {
    console.error("Ошибка при отправке данных:", error);
    return { success: false, message: "Ошибка сервера" }; // Возвращайте объект с успехом
  }
};

export const addAdmin = async (adminData) => {
  const login1 = Cookies.get("login");
  const hash1 = Cookies.get("session");

  const newAdminData = Object.assign({}, adminData, { login1 });
  const newAdminData2 = Object.assign({}, newAdminData, { hash1 });

  try {
    const response = await fetch("/api/admin/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newAdminData2),
    });
    const data = await response.json();

    if (!response.ok) {
      if (response.status === 401) {
        logout();
        throw new Error(data.message || "Не зарегистрированный пользователь");
      } else {
        throw new Error(data.message || "Ошибка при получении данных");
      }
    }

    return data;
  } catch (error) {
    console.error("Ошибка при добавлении администратора:", error);
    return { success: false, message: "Ошибка сервера" };
  }
};
export const fetchAdmins = async () => {
  const login = Cookies.get("login");
  const hash = Cookies.get("session");

  try {
    const response = await fetch("/api/admin/list", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ login, hash }),
    });
    const data = await response.json();

    if (!response.ok) {
      if (response.status === 401) {
        logout();
        throw new Error(data.message || "Не зарегистрированный пользователь");
      } else {
        throw new Error(data.message || "Ошибка при получении данных");
      }
    }

    return data;
  } catch (error) {
    console.error("Error during fetch:", error);
    throw error;
  }

  // try {
  //   const response = await fetch("http://127.0.0.1:5000/api/admin/list");
  //   return await response.json();
  // } catch (error) {
  //   console.error("Ошибка при получении списка администраторов:", error);
  //   return { success: false, message: "Ошибка сервера" };
  // }
};
export const sendfeedback = async (data) => {
  const login = Cookies.get("login");
  const hash = Cookies.get("session");

  const newFeedbackData = Object.assign({}, data, { login });
  const newFeedbackData2 = Object.assign({}, newFeedbackData, { hash });

  try {
    const response = await fetch("/api/newfeedback", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newFeedbackData2),
    });
    const data = await response.json();

    if (!response.ok) {
      if (response.status === 401) {
        logout();
        throw new Error(data.message || "Не зарегистрированный пользователь");
      } else {
        throw new Error(data.message || "Ошибка при получении данных");
      }
    }

    return data;
  } catch (error) {
    console.error("Ошибка при отправке данных:", error);
    return { success: false, message: "Ошибка сервера" }; // Возвращайте объект с успехом
  }
};
export const fetchfeedback = async () => {
  try {
    const response = await fetch("/api/get_feedback");
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Ошибка при получении данных");
    }

    return data;
  } catch (error) {
    console.error("Error during fetch:", error);
    throw error;
  }
};

export const deleteAdmin = async (id) => {
  const login = Cookies.get("login");
  const hash = Cookies.get("session");

  const toDelete = { login, hash };
  toDelete["id"] = id;

  try {
    const response = await fetch(`/api/delete`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(toDelete),
    });

    const data = await response.json();

    if (!response.ok) {
      if (response.status === 401) {
        logout();
        throw new Error(data.message || "Не зарегистрированный пользователь");
      } else {
        throw new Error(data.message || "Ошибка при получении данных");
      }
    }

    return data;
  } catch (error) {
    console.error("Error during fetch:", error);
    throw error;
  }
};

function logout() {
  Cookies.remove("isAdmin");
  Cookies.remove("login");
  Cookies.remove("session");
  window.location.replace("/");
}
